import { camposDaAbertura, type DefinicaoDeCampo } from "../../nucleo/tickets-avancado";
import { EntradaDeCampo } from "./EntradaDeCampo";

interface Props {
  definicoes: readonly DefinicaoDeCampo[];
  valores: Record<string, unknown>;
  aoMudar: (valores: Record<string, unknown>) => void;
}

/** Campos personalizados no formulário de abertura do chamado. */
export function CamposNaAbertura({ definicoes, valores, aoMudar }: Props) {
  const visiveis = camposDaAbertura(definicoes, valores);
  if (visiveis.length === 0) return null;
  return (
    <div data-testid="campos-na-abertura">
      {visiveis.map((campo) => (
        <EntradaDeCampo
          key={campo.id}
          campo={campo}
          valor={valores[campo.id] ?? null}
          aoMudar={(valor) => aoMudar({ ...valores, [campo.id]: valor })}
        />
      ))}
    </div>
  );
}
